/* eslint-disable indent */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
// import { useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../../../utils'
import { Button, buttonModes, buttonTypes, Icon, iconNames } from '../../../../../../components'
import '../../../common-elements-style.scss'
import { SimulationDialogList } from '../../../../../simulations'

export const FlowElementEndAboutPanel = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  variables,
  resources,
  products,
  locations,
  weather_data
}) => {
  const { t } = useTranslation()
  // const dispatch = useDispatch()

  const [openDialog, setOpenDialog] = useState(false)

  const onClickSimulation = (e) => {
    e.stopPropagation()

    const pid = currentProject?.id || null
    const sid = currentScenario?.id || null
    const fid = currentFlowGroup?.id || null

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementEndAboutPanel.onClickSimulation()', { pid, sid, fid })
    setOpenDialog(true)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementEndAboutPanel.render()', {})

  return (
    <div className="FlowElementEndAboutPanel">
      <form>
        {/* == SIMULATION == */}
        <Grid container spacing={2} style={{ padding: '30px 10px 20px' }}>
          {/*  button  */}
          <Grid item xs={12} sm={12}>
            <Button
              mode={buttonModes.PRIMARY_ACTION}
              type={buttonTypes.BUTTON}
              text={t('common.save')}
              className="common_fullwidth"
              icon={<Icon name={iconNames.SIMULATION} size={14} />}
              onClick={onClickSimulation}
            />
          </Grid>
        </Grid>
      </form>
      {openDialog && (
        <SimulationDialogList
          setOpenDialog={setOpenDialog}
          currentProject={currentProject}
          currentScenario={currentScenario}
          variables={variables}
          resources={resources}
          products={products}
          locations={locations}
          weather_data={weather_data}
        />
      )}
    </div>
  )
}

FlowElementEndAboutPanel.displayName = 'FlowElementEndAboutPanel'

FlowElementEndAboutPanel.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  // -- Scenario's Attributes
  resources: PropTypes.arrayOf(PropTypes.object),
  variables: PropTypes.arrayOf(PropTypes.object),
  locations: PropTypes.arrayOf(PropTypes.object),
  weather_data: PropTypes.arrayOf(PropTypes.object),
  parameters: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object)
}

FlowElementEndAboutPanel.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  // -- Scenario's Attributes
  resources: [],
  variables: [],
  locations: [],
  weather_data: [],
  parameters: [],
  products: []
}
